import application from "./application";
import auth from "./auth";
import drawer from "./drawer";
import job from "./job";
import prize from "./prize";
import site from "./site";
import user from "./user";

import { ApiService } from "./Api.service";

export default {
  ...application,
  ...auth,
  ...drawer,
  ...job,
  ...prize,
  ...site,
  ...user,
  apiService: {
    class: ApiService,
    public: true,
    arguments: [
      { BASE_URL: "/api" },
      { $ref: "accessTokenService" },
      { $ref: "navigationService" }
    ]
  }
};
